<template>
    <Messages v-bind:profile_uid="user.profile_uid" v-bind:is_editable="is_editable" v-bind:user_role="user_role"/>
</template>

<script>
import Messages from "../../components/common/Messages.vue";
import { mapState } from "vuex";

export default {
    components: {
        Messages
    },
    props: {
        is_editable: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
		...mapState({
			user: "user"
		}),
	},
    data() {
        return {
            is_editable: false,
            user_role: "mentee"
        }
    }
}
</script>